import { render } from "./MainappBasicLayout.vue?vue&type=template&id=5d5a380f"
import script from "./MainappBasicLayout.vue?vue&type=script&lang=js"
export * from "./MainappBasicLayout.vue?vue&type=script&lang=js"

import "./MainappBasicLayout.vue?vue&type=style&index=0&id=5d5a380f&lang=css"
script.render = render

export default script